import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import config from '../../config';

import {
  CurrencyConversionRatesPropTypes,
  ExtendedCurrencyConversionRatesPropTypes,
  ImportStatsPropTypes,
} from '../../shared/propTypes/currencyConversionRate';
import { currencyConversionRatesImportColDefs } from '../../shared/columnDefinitions/currencyConversionRates';

import Button from '../../shared/button.component';
import Attachments from '../../shared/forms/linkAttachments.component';
import ImportGrid from '../shared/importGrid.component';

import { excelFileExtensions } from '../../shared/fileUpload/constants';
import { ADD_OR_UPDATE_VALUES } from '../shared/constants';
import { generateAssetPath } from '../../utils/assetsHelpers';
import ProgressBar from '../../shared/progressBar.component';

export default class CurrencyConversionRatesImport extends PureComponent {
  static propTypes = {
    currencyConversionRates: CurrencyConversionRatesPropTypes,
    extendedUploadedCurrencyConversionRates: ExtendedCurrencyConversionRatesPropTypes,
    isFetchingCurrencyConversionRates: PropTypes.bool.isRequired,
    uploadCurrencyConversionRates: PropTypes.func.isRequired,
    uploadingCurrencyConversionRates: PropTypes.bool.isRequired,
    importingCurrencyConversionRates: PropTypes.bool.isRequired,
    importingCurrencyConversionRatesProgress: PropTypes.number.isRequired,
    files: PropTypes.arrayOf(PropTypes.instanceOf(File)),
    importCurrencyConversionRates: PropTypes.func.isRequired,
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    templateFileName: PropTypes.string.isRequired,
    importStats: ImportStatsPropTypes,
  };


  submitImport = () => {
    const {
      importCurrencyConversionRates,
      extendedUploadedCurrencyConversionRates,
    } = this.props;

    importCurrencyConversionRates(extendedUploadedCurrencyConversionRates);
  };

  getRawFile = file => {
    const { uploadCurrencyConversionRates } = this.props;
    uploadCurrencyConversionRates(file);
  };

  render() {
    const {
      uploadingCurrencyConversionRates,
      isFetchingCurrencyConversionRates,
      importingCurrencyConversionRatesProgress,
      importingCurrencyConversionRates,
      templateFileName,
      extendedUploadedCurrencyConversionRates,
      importStats,
    } = this.props;

    const shouldDisableSubmit = !importStats.loaded
      || importingCurrencyConversionRates
      || uploadingCurrencyConversionRates
      || Boolean(importStats.loaded && importStats.errors)
      || !extendedUploadedCurrencyConversionRates
        .find(currencyConversionRates => currencyConversionRates.addOrUpdate !== ADD_OR_UPDATE_VALUES.NO_CHANGE);

    return (
      <div>
        {extendedUploadedCurrencyConversionRates.length
          ? (
            <div className="text-center">
              {`Currency Conversion Rates load complete. ${importStats.loaded} records loaded`}
              {`, ${importStats.errors} errors`}
              {`, ${importStats.adds} adds`}
              {`, ${importStats.updates} updates.`}
            </div>
          ) : null
        }
        {
          importingCurrencyConversionRates && <ProgressBar progress={importingCurrencyConversionRatesProgress} />
        }
        <ImportGrid
          data={extendedUploadedCurrencyConversionRates}
          hasValidationErrors={importStats.errors !== 0}
          className="admin-import-grid"
          columnDefs={currencyConversionRatesImportColDefs}
          isLoading={
            uploadingCurrencyConversionRates
            || isFetchingCurrencyConversionRates
            || importingCurrencyConversionRates
          }
        />
        <div className="d-flex flex-row align-items-center page-content-container">
          <Attachments
            maxFileSize={10}
            headerText={''}
            getRawFile={this.getRawFile}
            acceptTypes={excelFileExtensions}
            disabled={
              uploadingCurrencyConversionRates
              || isFetchingCurrencyConversionRates
              || importingCurrencyConversionRates
            }
            downloadTemplateButton={
              <a
                className="hamburger-action"
                role="button"
                tabIndex="1"
                download={templateFileName}
                href={generateAssetPath(config.templates.CURRENCY_CONVERSION_RATES)}
              >
                {' click to download '}
              </a>
            }
          />
          <Button
            type="button"
            kind="primary"
            disabled={shouldDisableSubmit}
            className="ml-auto"
            onClick={this.submitImport}
          >
            Submit
          </Button>
        </div>
      </div>
    );
  }
}
